import projectService from "@/service/project-service"
import searchService from "@/service/search-service"
import { isNonEmptyString } from "@/utils"

const getSelectedCategories = filterCategories =>
  filterCategories
    .filter(category => category.selected)
    .reduce((acc, category) => {
      acc[category.value] = true
      return acc
    }, {})

export default {
  mealsRef(projectId) {
    return projectService
      .projectRef(projectId)
      .child("data")
      .child("meals")
  },

  mealRef(projectId, mealId) {
    return this.mealsRef(projectId).child(mealId)
  },

  async addMeal(projectId, meal) {
    const key = this.mealsRef(projectId).push().key
    meal.id = key
    meal.dateCreated = Date.now()
    meal.dateUpdated = Date.now()
    await this.mealRef(projectId, key).set(meal)
    return meal
  },

  updateMeal(projectId, mealId, meal) {
    meal.dateUpdated = Date.now()
    return this.mealRef(projectId, mealId).update(meal)
  },

  removeMeal(projectId, mealId) {
    return this.mealRef(projectId, mealId).set(null)
  },

  onMealsChanged(projectId, callback, errorCallback) {
    this.mealsRef(projectId).on(
      "value",
      snapshot => {
        const meals = snapshot.val() || {}
        const mealsWithIds = Object.keys(meals).reduce((acc, mealId) => {
          const meal = meals[mealId]
          acc[mealId] = {
            allergens: [],
            badges: [],
            categories: [],
            ...meal,
            id: mealId
          }
          return acc
        }, {})
        callback(mealsWithIds)
      },
      errorCallback
    )
  },

  offMealsChanged(projectId) {
    this.mealsRef(projectId).off()
  },

  filterPredicate(filterText) {
    if (!isNonEmptyString(filterText)) {
      return () => true
    }
    const searchQuery = searchService.contains(filterText)
    return meal => searchQuery(meal.name) || meal.categories.some(searchQuery)
  },

  filterCategoriesPredicate(filterCategories) {
    const selectedCategories = getSelectedCategories(filterCategories)
    if (Object.keys(selectedCategories).length === 0) {
      return () => true
    }
    return meal =>
      Object.values(meal.categories).some(
        category => selectedCategories[category]
      )
  },

  unionComparator: (cmp1, cmp2) => (meal1, meal2) => {
    const result = cmp1(meal1, meal2)
    if (result !== 0) {
      return result
    }
    return cmp2(meal1, meal2)
  },

  compareByCategoriesCountDesc(filterCategories) {
    const selectedCategories = getSelectedCategories(filterCategories)
    return (meal1, meal2) => {
      const meal1Count = meal1.categories.filter(
        category => selectedCategories[category]
      ).length
      const meal2Count = meal2.categories.filter(
        category => selectedCategories[category]
      ).length
      return meal2Count - meal1Count
    }
  },

  compareByNameAsc(meal1, meal2) {
    return meal1.name.localeCompare(meal2.name)
  },

  compareByDateDesc(meal1, meal2) {
    return (meal2.dateUpdated || 0) - (meal1.dateUpdated || 0)
  }
}
